var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 1.66992C11.4017 1.66992 10.8035 1.89671 10.3502 2.35026L2.9719 9.72787C2.83191 9.86786 2.72938 10.042 2.67503 10.2331L1.68609 13.696C1.66171 13.7817 1.66065 13.8723 1.68304 13.9585C1.70543 14.0448 1.75046 14.1234 1.81345 14.1864C1.87645 14.2494 1.95513 14.2945 2.04137 14.3169C2.1276 14.3392 2.21824 14.3382 2.30393 14.3138L5.76747 13.3249L5.76813 13.3242C5.95797 13.2696 6.13163 13.1684 6.27203 13.028L13.6496 5.64974C14.5567 4.7427 14.5567 3.2573 13.6496 2.35026C13.1963 1.89671 12.5981 1.66992 11.9999 1.66992ZM9.37425 4.74023L11.2597 6.62565L5.56435 12.321C5.54481 12.3404 5.52005 12.3552 5.49208 12.3633L5.16266 12.457L3.54221 10.8366L3.63662 10.5072V10.5065C3.64426 10.4796 3.65826 10.4556 3.67893 10.4349L9.37425 4.74023Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.1de9b8a2d489c6e582cabbad92cffe11.svg";
export { ForwardRef as ReactComponent };